import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
/**
 * Returns true when a category's tags object has no user-applied values.
 * Numeric keys (e.g. "0":"ribfracture") are artifact keys from regularizeFilterData
 * and are intentionally ignored.
 */
var isEmptyTagsObject = function isEmptyTagsObject(tags) {
  for (var _i = 0, _Object$entries = Object.entries(tags); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (!isNaN(Number(key))) continue; // skip numeric artifact keys
    if (Array.isArray(value) && value.length > 0) return false;
    if (value && _typeof(value) === "object" && !Array.isArray(value) && Object.keys(value).length > 0) return false;
  }
  return true;
};

/**
 * Returns true when filtersData has no real user-applied filters.
 *
 * Checks each field directly for non-empty values rather than doing a strict
 * structure comparison, so missing optional keys (e.g. dropdownTags) or
 * numeric artifact keys in tags objects don't produce false negatives.
 */
var isFiltersDataEmpty = function isFiltersDataEmpty(filtersData) {
  if (!filtersData) return true;
  for (var _i2 = 0, _Object$entries2 = Object.entries(filtersData); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      value = _Object$entries2$_i[1];
    if (value === null || value === undefined) continue;

    // Date range fields: empty when all entries are null
    if (Array.isArray(value) && value.every(function (v) {
      return v === null;
    })) continue;

    // Plain arrays (custom_tags, task_status, task_owner, etc.)
    if (Array.isArray(value)) {
      if (value.length > 0) return false;
      continue;
    }

    // Category objects with a tags sub-object (site, present_findings, etc.)
    if (_typeof(value) === "object" && value.tags && _typeof(value.tags) === "object") {
      if (!isEmptyTagsObject(value.tags)) return false;
      continue;
    }
  }
  return true;
};
export default isFiltersDataEmpty;